import { generateQuery } from "helpers/utis";
export const AuthApi = {
  empCodesApi: {
    api: "/auth/get-company",
    baseURL: "user",
    method: "get",
  },
  sendEmailVerificationCode: {
    api: "/email-verify/send-otp-existing-user",
    baseURL: "user",
    method: "post",
  },
  verifyEmailVerificationCode: {
    api: "/email-verify/verify_otp",
    baseURL: "user",
    method: "post",
  },
  updateLoginEmail: {
    api: "/email-verify/update_email",
    method: "put",
    baseURL: "user",
  },
  loginApi: {
    api: "/auth/login",
    baseURL: "user",
    method: "post",
  },
  resetPasswordApi: {
    api: "/employee/reset-password",
    baseURL: "user",
    method: "post",
  },
  mailResetPasswordApi: {
    api: "/employee/forgot-password-admin",
    baseURL: "user",
    method: "put",
  },
  forgetPasswordApi: {
    url: "/auth/change-password",
    baseURL: "user",
    method: "post",
    email: "",
    get api() {
      return this.url + "/" + this.email;
    },
  },
  getValidToken: {
    url: "/auth/check-link",
    baseURL: "user",
    method: "get",
    query: {
      slug: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const UserMgmtApi = {
  getAllEmployeeApi: {
    url: "/employee/get-all-employee",
    baseURL: "user",
    query: {
      page: 1,
      limit: 10,
      type: "",
      search: "",
      sort_by: "",
      order_by: "",
      role: "",
      project_id: "",
      trade_id: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getEmployeeApi: {
    url: "/employee/get-employee",
    baseURL: "user",
    url_id: "",
    get api() {
      return this.url + "/" + this.url_id;
    },
    method: "get",
  },
  addEmployeeApi: {
    api: "/employee/add-employee",
    baseURL: "user",
    method: "post",
  },
  sendEmailOTPNewUser: {
    api: "/email-verify/send_otp",
    baseURL: "user",
    method: "post",
  },
  verifyEmailOTP: {
    api: "/email-verify/verify_otp",
    baseURL: "user",
    method: "post",
  },

  updateEmployeeApi: {
    api: "/employee/edit-employee",
    baseURL: "user",
    method: "put",
  },
  multipleStatusUpdate: {
    api: "/employee/multiple-status-update",
    baseURL: "user",
    method: "put",
  },

  generatePasswordApi: {
    url: "/employee/generatePassword",
    baseURL: "user",
    url_id: "",
    get api() {
      return this.url + "/" + this.url_id;
    },
    method: "get",
  },

  getTradeDropDown: {
    api: "/trade/get-all-trades",
    baseURL: "user",
    method: "get",
  },
  deleteUserApi: {
    url: "/employee/del-employee",
    baseURL: "user",
    url_id: "",
    get api() {
      return this.url + "/" + this.url_id;
    },
    method: "delete",
  },
  updateUserStatusApi: {
    url: "/employee/inactive-employee",
    baseURL: "user",
    type: "",
    url_id: "",
    get api() {
      return this.url + "/" + this.type + "/" + this.url_id;
    },
    method: "put",
  },
  getExistingEmpApi: {
    url: "/employee/valid-employee",
    baseURL: "user",
    method: "get",
    query: {
      employee_code: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },

  getdownloadUserApi: {
    url: "/employee/get-all-employee",
    baseURL: "user",
    method: "get",
    query: {
      page: 1,
      limit: 10,
      role: "",
      from_date: "",
      to_date: "",
      trade_id: "",
      project_id: "",
      role_id: "",
      sort_by: "",
      order_by: "",
      exportType: "",
      isExport: "",
      type: "",
      search: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },

  getProjectsListApi: {
    url: "/project/all-projects",
    baseURL: "user",
    method: "get",
    query: {
      page: 1,
      size: 10,
      type: "active",
      search: "",
      sort_by: "",
      order_by: "",
      role: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
  },

  getAssignedProjectsApi: {
    api: "/project/all-projects-options",
    baseURL: "user",
    method: "get",
  },

  getReportsAssignedProjectsApi: {
    url: "/project/all-projects-options",
    baseURL: "user",
    method: "get",
    query: {
      type: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  employeeUploadFileApi: {
    api: "/employee/employee-upload",
    baseURL: "user",
    method: "post",
  },
  imageUploadApi: {
    api: "/upload/image",
    baseURL: "user",
    method: "post",
  },
};
export const ProjectApi = {
  getAllProjectApi: {
    url: "/project/all-projects",
    baseURL: "user",
    query: {
      page: 1,
      limit: 10,
      type: "active",
      search: "",
      sort_by: "",
      order_by: "",
      region: "",
      wings: "",
      project_id: "",
      work_location: "",
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
  },

  getProgessStatusAPI: {
    url: "/attendance/status/",
    baseURL: "user",
    method: "post",
    id: "",

    api(id) {
      return `${this.url}${id}`;
    },
  },

  getInactiveProjectApi: {
    url: "/project/all-projects",
    baseURL: "user",
    query: {
      page: 1,
      limit: 10,
      type: "inactive",
      search: "",
      sort_by: "",
      order_by: "",
      region: "",
      wings: "",
      work_location: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  updateProjectStatusApi: {
    url: "/project/project-status",
    baseURL: "user",
    type: "",
    url_id: "",
    get api() {
      return this.url + "/" + this.type + "/" + this.url_id;
    },
    method: "put",
  },
  addProjectApi: {
    api: "/project/add-project",
    baseURL: "user",
    method: "post",
  },

  getSingleProjectApi: {
    url: "/project/project-details/",
    baseURL: "user",
    method: "get",
    project_id: null,
    get api() {
      return this.url + this.project_id;
    },
  },
  getWingsApi: {
    url: "/employee/option-list/",
    baseURL: "user",
    method: "get",
    type: null,
    get api() {
      return this.url + this.type;
    },
  },
  updateProjectApi: {
    api: "/project/edit-project",
    baseURL: "user",
    method: "put",
  },

  deleteProject: {
    url: "/project/delete-project/",
    baseURL: "user",
    method: "delete",
    project_id: null,
    get api() {
      return this.url + this.project_id;
    },
  },
  getRegionsApi: {
    api: "/master/get-all-master-region",
    baseURL: "user",
    method: "get",
  },
  getRegionsFilterApi: {
    url: "/master/get-region/",
    baseURL: "user",
    method: "get",
    type: null,
    get api() {
      return this.url + this.type;
    },
  },
  checkPhaseCode: {
    api: "/project/phase-code-exist",
    baseURL: "user",
    method: "post",
  },
  getFlatApi: {
    api: "/master/all-flats",
    baseURL: "user",
    method: "get",
  },
  getProjectTypeApi: {
    api: "/master/all-projecttypes",
    baseURL: "user",
    method: "get",
  },
  projectUploadFileApi: {
    api: "/project/bulk-upload-project",
    baseURL: "user",
    method: "post",
  },
  projectDownloadApi: {
    api: "/project/project-details-excel",
    baseURL: "user",
    method: "get",
  },
};

export const AboutApi = {
  getAboutApi: {
    api: "/auth/get-about",
    baseURL: "user",
    method: "get",
  },
  getTermsApi: {
    api: "/auth/get-terms/2",
    baseURL: "user",
    method: "get",
  },
  getPoliciesApi: {
    api: "/auth/get-terms/3",
    baseURL: "user",
    method: "get",
  },
};

// Activity Module
export const ActivityApi = {
  getActivityApi: {
    url: "/activity/get-all-admin-actitvity",
    baseURL: "user",
    query: {
      page: 1,
      limit: "",
      type: "active",
      search: "",
      sort_by: "",
      order_by: "",
      trade_id: "",
      region_name: "",
      unit_measurement: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getRegionsApi: {
    api: "/master/get-all-master-region",
    baseURL: "user",
    method: "get",
  },

  getSingleActivityApi: {
    url: "/activity/get-admin-actitvity/",
    baseURL: "user",
    method: "get",
    activity_master_id: null,
    active_status: null,

    get api() {
      return this.url + this.activity_master_id + `/${this.active_status}`;
    },
  },

  getProgessStatusAPI: {
    url: "/attendance/status/",
    baseURL: "user",
    method: "post",
    id: "",

    api(id) {
      return `${this.url}${id}`;
    },
  },

  deleteActivity: {
    url: "/activity/delete-admin-activity/",
    baseURL: "user",
    method: "delete",
    activity_master_id: null,
    get api() {
      return this.url + this.activity_master_id;
    },
  },
  addActivityApi: {
    api: "/activity/create-activity",
    baseURL: "user",
    method: "post",
  },
  updateActivityApi: {
    api: "/activity/edit-admin-activity",
    baseURL: "user",
    method: "put",
  },
  getTradeDropDown: {
    api: "/trade/get-all-trades",
    baseURL: "user",
    method: "get",
  },
  getUomDropDown: {
    api: "/activity/getUnitsofMeasurements",
    baseURL: "user",
    method: "get",
  },
  getActivityDropDown: {
    url: "/activity/get-all-master-activity/",
    baseURL: "user",
    method: "get",
    activity_trade_id: null,
    get api() {
      return this.url + this.activity_trade_id;
    },
  },

  activityUploadFileApi: {
    api: "/activity/bulk-upload-activity",
    baseURL: "user",
    method: "post",
  },
  activityReport: {
    api: "/activity/activity-report?type=active",
    baseURL: "user",
    method: "get",
  },
  inactiveActivityReport: {
    api: "/activity/activity-report?type=inactive",
    baseURL: "user",
    method: "get",
  },
  getInactiveActivityApi: {
    url: "/activity/get-all-admin-actitvity",
    baseURL: "user",
    query: {
      page: 1,
      limit: "",
      type: "inactive",
      search: "",
      sort_by: "",
      order_by: "",
      trade_id: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  updateActivityStatusApi: {
    url: "/activity/activity-status",
    baseURL: "user",
    activity_id: "",
    type: "",
    get api() {
      return this.url + "/" + this.activity_id + "/" + this.type;
    },
    method: "patch",
  },
};

// Reports Module
export const ReportsApi = {
  getReportsApi: {
    url: "/report/get-list",
    baseURL: "user",
    method: "get",
    query: {
      page: 1,
      size: 10,
      type: "",
      search: "",
      sort_by: "",
      order_by: "",
      wings_id: "",
      project_id: "",
      fromDate: "",
      toDate: "",
      trade_id: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery(queryParams) {
      this.query = { ...this.query, ...queryParams };
    },
  },
  getFilterReportApi: {
    api: "/report/get-list",
    baseURL: "user",
    method: "get",
  },
  getFilterReportOptionApi: {
    api: "/report/get-filters",
    baseURL: "user",
    method: "get",
  },

  getFilterWingsOptions: {
    url: "/report/get-filters",
    baseURL: "user",
    method: "get",
    query: {
      project_id: null,
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
  },
};

// Report Module
export const ReportMgmtApi = {
  getReportApi: {
    url: "/report",
    baseURL: "user",
    url_id: "",
    get api() {
      return this.url + "/" + this.url_id;
    },
    method: "get",
  },
  updateReportsApi: {
    url: "/employee/activities",
    baseURL: "user",
    url_id: "",
    get api() {
      return this.url + "/" + this.url_id;
    },
    method: "put",
  },
  downloadFileApi: {
    api: "/report/get-download-report",
    baseURL: "user",
    method: "post",
  },

  savaFilterApi: {
    api: "/saved-filter/create",
    method: "post",
    baseURL: "user",
  },
};

export const AttendanceApi = {
  getAttendanceApi: {
    url: "/attendance/get-attendance",
    baseURL: "user",
    method: "get",
    query: {
      page: 1,
      limit: 10,
      from_date: "",
      to_date: "",
      trade: "",
      project_id: "",
      sort_by: "",
      order_by: "",
      isExport: "",
      type: "",
      search: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getdownloadAttendanceApi: {
    url: "/attendance/get-download-attendance-report",
    baseURL: "user",
    method: "get",
    query: {
      page: 1,
      limit: 10,
      from_date: "",
      to_date: "",
      trade: "",
      project_id: "",
      sort_by: "",
      order_by: "",
      isExport: "",
      type: "",
      search: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getEmpDetailApi: {
    url: "/attendance/get-emp-det-erp",
    baseURL: "user",
    method: "post",
    query: {
      code: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  createAttendanceApi: {
    api: "/attendance/create-attendance",
    baseURL: "user",
    method: "post",
  },
  attendanceUploadFileApi: {
    api: "/attendance/bulk-attendance-upload",
    baseURL: "user",
    method: "post",
  },
  generateManualCron: {
    api: "/attendance/employeeAttendanceCron",
    baseURL: "user",
    method: "post",
  },
  getProgessStatusAPI: {
    url: "/attendance/status/",
    baseURL: "user",
    method: "post",
    id: "",

    api(id) {
      return `${this.url}${id}`;
    },
  },
};

export const DashboardApi = {
  getTotalProjects: {
    api: "/dashboard/count",
    baseURL: "user",
    method: "get",
  },
  getDashboardFilterList: {
    api: "/dashboard/filter-count",
    baseURL: "user",
    method: "post",
  },
  wingWiseProductivity: {
    url: "/productivity/get-wing-wise-productivity",
    baseURL: "user",
    method: "get",
    query: {
      project_id: "",
      trade_id: "",
      from_date: "",
      to_date: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  attendanceGrapgData: {
    url: "/productivity/get-attendance-grade-wise-productivity",
    baseURL: "user",
    method: "get",
    query: {
      project_id: "",
      from_date: "",
      to_date: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  attendanceProjectsList: {
    api: "/project/all-projects-list",
    baseURL: "user",
    method: "get",
  },

  foremanWiseProductivity: {
    url: "/productivity/get-foreman-wise-productivity",
    baseURL: "user",
    method: "get",
    query: {
      project_id: "",
      trade_id: "",
      from_date: "",
      to_date: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  tradeWiseProductivity: {
    url: "/productivity/get-trade-wise-productivity",
    baseURL: "user",
    method: "get",
    query: {
      project_id: "",
      trade_id: "",
      from_date: "",
      to_date: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  tradeList: {
    api: "/productivity/get-trades",
    baseURL: "user",
    method: "get",
  },

  getAttendanceCategoryChartApi: {
    url: "/productivity/get-attendance-by-category",
    method: "get",
    baseURL: "user",
    query: {
      from_date: "",
      to_date: "",
      project_id: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery(queryParams) {
      this.query = { ...this.query, ...queryParams };
    },
  },
};

export const ProductivityApi = {
  getProductivityList: {
    url: "/employee/activities-with-metrics",
    baseURL: "user",
    method: "get",
    query: {
      page: 1,
      limit: 10,
      type: "",
      is_productive_flag: true,
      technician_code: "",
      isExport: "",
      from_date: "",
      to_date: "",
      project_id: "",
      trade_id: "",
      wings_id: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
    set addQuery(queryParams) {
      this.query = { ...this.query, ...queryParams };
    },
  },
  getFilterWingsOptions: {
    url: "/report/get-filters",
    baseURL: "user",
    method: "get",
    query: {
      project_id: null,
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
  },
  getTechnicianList: {
    api: "/employee/list/technicians",
    baseURL: "user",
    method: "get",
  },
  downloadXlApiWingWise: {
    api: "/productivity/get-wing-wise-productivity-abstract",
    baseURL: "user",
    method: "post",
  },
  downloadXlApiTechnicianWise: {
    api: "/productivity/get-technician-productivity",
    baseURL: "user",
    method: "post",
  },
  downloadXlApiActivityWise: {
    api: "/productivity/get-activity-productivity",
    baseURL: "user",
    method: "post",
  },
  getWingWiseProductivity: {
    api: "/productivity/get-wing-wise-productivity",
    baseURL: "user",
    method: "post",
  },

  getTradeDropDown: {
    api: "/trade/get-all-trades",
    baseURL: "user",
    method: "get",
  },
  getUomDropDown: {
    api: "/activity/getUnitsofMeasurements",
    baseURL: "user",
    method: "get",
  },
};

export const MasterQuantityAddAPIs = {
  getWorkAreaOptionsApi: {
    url: "/project/flats-based-areas",
    baseURL: "user",
    method: "get",
    query: {
      project_id: "",
    },
    api(project_id, wing_id, floor_id, unit_id, worklocationtype) {
      return `${this.url}/${project_id}/${wing_id}/${floor_id}/${unit_id}/${worklocationtype}`;
    },
  },
  getProjectWorkAreaOptionsApi: {
    url: "/master-quantity",
    baseURL: "user",
    method: "get",
    query: {
      project_id: "",
    },
    api(project_id, worklocationtype) {
      return `${this.url}/${project_id}/work-locations/${worklocationtype}`;
    },
  },

  getTradeOptionsApi: {
    url: "/trade/",
    baseURL: "user",
    method: "get",
    type: "get-all-trades",
    query: {},
    get api() {
      return this.url + this.type + generateQuery(this.query);
    },
  },

  getActivityOptionsApi: {
    url: "/master-quantity/activity/",
    baseURL: "user",
    method: "get",
    type: "activity",
    query: {
      trade_id: "",
    },
    api(trade_id) {
      return this.url + trade_id + generateQuery(this.query);
    },
  },

  getSubActivityOptionsApi: {
    url: "/master-quantity/sub_activity/",
    baseURL: "user",
    method: "get",
    type: "sub-activity",
    query: {
      activity_id: "",
    },
    api(activity_id) {
      return this.url + activity_id + generateQuery(this.query);
    },
  },

  getMasterQuantityWingsApi: {
    url: "/project/project-wings/",
    baseURL: "user",
    method: "get",
    project_id: null,
    location_type: null,

    api(project_id, location_type) {
      return this.url + project_id + "/" + location_type;
    },
  },
  getMasterQuantityWingsBasedFloorApi: {
    url: "/project/wings-based-floors/",
    baseURL: "user",
    method: "get",
    project_id: null,
    wings_id: null,
    external_or_internal: null,

    api(project_id, wings_id, external_or_internal) {
      return (
        this.url + project_id + "/" + wings_id + "/" + external_or_internal
      );
    },
  },

  getMasterQuantityFloorBasedUnitsApi: {
    url: "/project/floors-based-flats/",
    baseURL: "user",
    method: "get",
    project_id: null,
    wings_id: null,
    external_or_internal: null,
    floor_id: null,

    api(project_id, wings_id, external_or_internal, floor_id) {
      return (
        this.url +
        project_id +
        "/" +
        wings_id +
        "/" +
        floor_id +
        "/" +
        external_or_internal
      );
    },
  },

  getSingleProjectApi: {
    url: "/master-quantity/project-details/",
    baseURL: "user",
    method: "get",
    project_id: null,
    work_location: null,
    api(project_id, location_type) {
      return this.url + project_id + "/" + location_type;
    },
  },

  getMasterQuantityFlatsBasedAreasApi: {
    url: "/project/flats-based-areas/",
    baseURL: "user",
    method: "get",
    project_id: null,
    wings_id: null,
    external_or_internal: null,
    floor_id: null,
    unit_id: null,

    api(project_id, wings_id, external_or_internal, floor_id, unit_id) {
      return (
        this.url +
        project_id +
        "/" +
        wings_id +
        "/" +
        floor_id +
        "/" +
        unit_id +
        "/" +
        external_or_internal
      );
    },
  },

  getProjectSummaryApi: {
    url: "/master-quantity/project-details/",
    baseURL: "user",
    method: "get",
    project_id: null,
    work_location: "",
    query: {
      page: 1,
      limit: 10,
      type: "",
      sort_by: "",
      order_by: "",
      search: "",
    },
    get api() {
      return this.url + this.project_id + "/" + this.work_location;
    },
  },

  submitMasterQuantityApi: {
    api: "/master-quantity/create",
    baseURL: "user",
    method: "post",
  },

  updateMasterQuantityApi: {
    api: "/master-quantity/update/",
    baseURL: "user",
    method: "put",
  },

  getMasterQuantityFinalViewApi: {
    url: "/master-quantity/list/",
    baseURL: "user",
    method: "get",
    project_id: null,
    work_location: "",
    query: {
      project_id: "",
      wing_id: "",
      floor_id: "",
      unit_id: "",
      work_area_id: "",
      trade_id: "",
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
  },
  masterQuantityReport: {
    api: "/master-quantity/export",
    baseURL: "user",
    method: "get",
  },
};

export const RegionApi = {
  getRegionListApi: {
    url: "/region/get-all",
    method: "get",
    query: {
      page: 1,
      limit: 10,
      type: "",
      search: "",
      sort_by: "",
      order_by: "",
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
  },

  getRegionByIdApi: {
    url: "/region/get",
    method: "get",
    baseURL: "user",
    url_id: "",
    api(id) {
      return this.url + "/" + id;
    },
  },

  createRegionApi: {
    api: "/region/create",
    method: "post",
  },

  updateRegionApi: {
    url: "/region/update",
    method: "put",
    url_id: "",
    baseURL: "user",
    api(id) {
      return this.url + "/" + id;
    },
  },

  changeRegionStatusApi: {
    api: (id, status) => `/region/status/${id}/${status}`,
    method: "put",
    baseURL: "user",
  },

  deleteRegionApi: {
    url: "/region/delete",
    method: "delete",
    baseURL: "user",
    url_id: "",
    api(id) {
      return this.url + "/" + id;
    },
  },
};

export const WingsApi = {
  getWingsListApi: {
    url: "/wings/get-all",
    method: "get",
    query: {
      page: 1,
      limit: 10,
      type: "",
      search: "",
      sort_by: "",
      order_by: "",
    },

    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
  },

  getWingsByIdApi: {
    url: "/wings/get",
    method: "get",
    baseURL: "user",
    url_id: "",
    api(id) {
      return this.url + "/" + id;
    },
  },

  createWingsApi: {
    api: "/wings/create",
    method: "post",
  },

  updateWingsApi: {
    url: "/wings/update",
    method: "put",
    url_id: "",
    baseURL: "user",
    api(id) {
      return this.url + "/" + id;
    },
  },

  deleteWingsApi: {
    url: "/wings/delete",
    method: "delete",
    url_id: "",
    baseURL: "user",
    api(id) {
      return this.url + "/" + id;
    },
  },

  changeWingsStatusApi: {
    api: (id, status) => `/wings/status/${id}/${status}`,
    method: "put",
    baseURL: "user",
  },
};

export const FloorApi = {
  getFloorListApi: {
    url: "/floors/get-all",
    method: "get",
    query: {
      page: 1,
      limit: 10,
      type: "",
      search: "",
      sort_by: "",
      order_by: "",
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
  },

  getFloorByIdApi: {
    url: "/floors/get",
    method: "get",
    baseURL: "user",
    url_id: "",
    api(id) {
      return this.url + "/" + id;
    },
  },

  createFloorApi: {
    api: "/floors/create",
    method: "post",
  },

  updateFloorApi: {
    url: "/floors/update",
    method: "put",
    url_id: "",
    baseURL: "user",
    api(id) {
      return this.url + "/" + id;
    },
  },

  deleteFloorApi: {
    url: "/floors/delete",
    method: "delete",
    url_id: "",
    baseURL: "user",
    api(id) {
      return this.url + "/" + id;
    },
  },
  changeFloorStatusApi: {
    api: (id, status) => `/floors/status/${id}/${status}`,
    method: "put",
    baseURL: "user",
  },
};

export const UnitsApi = {
  getUnitsListApi: {
    url: "/flats/get-all",
    method: "get",
    query: {
      page: 1,
      limit: 10,
      type: "",
      search: "",
      sort_by: "",
      order_by: "",
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
  },
  getUnitsByIdApi: {
    url: "/flats/get",
    method: "get",
    baseURL: "user",
    url_id: "",
    api(id) {
      return this.url + "/" + id;
    },
  },
  createUnitsApi: {
    api: "/flats/create",
    method: "post",
  },
  updateUnitsApi: {
    url: "/flats/update",
    method: "put",
    url_id: "",
    baseURL: "user",
    api(id) {
      return this.url + "/" + id;
    },
  },
  deleteUnitsApi: {
    url: "/flats/delete",
    method: "delete",
    url_id: "",
    baseURL: "user",
    api(id) {
      return this.url + "/" + id;
    },
  },
  changeUnitStatusApi: {
    api: (id, status) => `/flats/status/${id}/${status}`,
    method: "put",
    baseURL: "user",
  },
};

export const workAreasApi = {
  getWorkAreasListApi: {
    url: "/workArea/get-all",
    method: "get",
    query: {
      page: 1,
      limit: 10,
      type: "",
      search: "",
      sort_by: "",
      order_by: "",
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
    get api() {
      return this.url + generateQuery(this.query);
    },
  },

  getWorkAreasByIdApi: {
    url: "/workArea/get",
    method: "get",
    baseURL: "user",
    url_id: "",
    api(id) {
      return this.url + "/" + id;
    },
  },

  createWorkAreasApi: {
    api: "/workArea/create",
    method: "post",
  },

  updateWorkAreasApi: {
    url: "/workArea/update",
    method: "put",
    url_id: "",
    baseURL: "user",
    api(id) {
      return this.url + "/" + id;
    },
  },

  deleteWorkAreasApi: {
    url: "/workArea/delete",
    method: "delete",
    url_id: "",
    baseURL: "user",
    api(id) {
      return this.url + "/" + id;
    },
  },
  changeWorkAreaStatusApi: {
    api: (id, status) => `/workArea/status/${id}/${status}`,
    method: "put",
    baseURL: "user",
  },
};
